<div class="p-d-flex p-flex-column sidebar-menu p-ai-center p-ai-sm-center p-ai-md-start p-ai-lg-start" *ngIf="menus">
  <div class="sidebar-menu-item" *ngFor="let menu of menus">
    <a (click)="menu.path == '/logout' ? this.sessionService.logout() : null" [routerLink]="[ menu.path ]">
      <p class="sidebar-menu-label p-d-flex p-ai-center p-m-0" [ngClass]="menu.active ? 'active' : ''" style="opacity: .45">
        <img class="p-mr-2" [src]=" 'assets/images/menu/' + menu.icon " width="25px" />
        <span class="p-d-none p-d-md-inline-flex">{{ menu.nombre }}</span>
      </p>
    </a>
  </div>

</div>




